// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__chYqX","label":"CategoryService_label__1jZN-","location":"CategoryService_location__s18-R"};